import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import ListingCard from "../components/ListingCard";
import { Search as SearchIcon } from "lucide-react";
import { listingsAPI } from "../lib/api";

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const castello = params.get("castello") || "";
  const [results, setResults] = useState([]);

  useEffect(() => {
    const apiParams = { limit: 60 };
    if (q) apiParams.q = q;
    if (castello) apiParams.castello = castello;
    listingsAPI.list(apiParams).then(setResults).catch(() => setResults([]));
  }, [q, castello]);

  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <div className="bg-white border border-slate-200 rounded-2xl p-6 mb-6">
        <div className="flex items-center gap-2 text-xs text-slate-500">
          <SearchIcon className="w-4 h-4"/>
          <span>Risultati di ricerca</span>
        </div>
        <h1 className="text-2xl font-black text-[#1d3d3a] mt-1">
          {q ? `"${q}"` : "Tutti gli annunci"}
          {castello && <span className="text-slate-500 font-normal text-lg"> · {castello}</span>}
        </h1>
        <p className="text-sm text-slate-500 mt-1">{results.length} annunci trovati</p>
      </div>

      {results.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-xl border border-slate-200">
          <SearchIcon className="w-12 h-12 mx-auto text-slate-300 mb-3"/>
          <p className="text-slate-600 font-semibold">Nessun annuncio trovato</p>
          <p className="text-sm text-slate-500 mt-1">Prova con parole chiave diverse o <Link to="/" className="text-[#e86a24] hover:underline">esplora le categorie</Link></p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {results.map(l => <ListingCard key={l.id} listing={l} />)}
        </div>
      )}
    </div>
  );
}
